<template>
  <div class="open-door-settings">
    <div class="config-section-title">{{ $t('machineConfig.openDoorSetting') }}</div>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.detectType')">
          <el-select 
            :value="localValue.detectType" 
            @change="handleChange('detectType', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in detectTypeList" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.cameraSelect')">
          <el-select 
            :value="localValue.cameraSelect" 
            @change="handleChange('cameraSelect', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in cameraSelectList" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.pendOrderAlarm')">
          <el-select 
            :value="localValue.pendOrderAlarmSwitch" 
            @change="handleChange('pendOrderAlarmSwitch', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in yesNo" 
              :key="item.id" 
              :label="item.label" 
              :value="+item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.pendOrderAlarmSwitch === 1">
        <el-form-item :label="$t('machineConfig.pendOrderAlarmNum')">
          <el-input 
            :value="localValue.pendOrderAlarmNum" 
            @input="handleChange('pendOrderAlarmNum', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.times') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.pendOrderAlarmSwitch === 1">
        <el-form-item :label="$t('machineConfig.pendOrderAlarmDisableMachine')">
          <el-input 
            :value="localValue.pendOrderAlarmDisableMachine" 
            @input="handleChange('pendOrderAlarmDisableMachine', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">orders</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.orderTimeoutWarn')">
          <el-select 
            :value="localValue.orderTimeoutWarnSwitch" 
            @change="handleChange('orderTimeoutWarnSwitch', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in yesNo" 
              :key="item.id" 
              :label="item.label" 
              :value="+item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.orderTimeoutWarnSwitch === 1">
        <el-form-item :label="$t('machineConfig.orderTimeoutWarnTime')">
          <el-input 
            :value="localValue.orderTimeoutWarnTime" 
            @input="handleChange('orderTimeoutWarnTime', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.minutes') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.longTimeSettleOrder')">
          <el-select 
            :value="localValue.longTimeSettleOrderSwitch" 
            @change="handleChange('longTimeSettleOrderSwitch', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in yesNo" 
              :key="item.id" 
              :label="item.label" 
              :value="+item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.longTimeSettleOrderSwitch === 1">
        <el-form-item :label="$t('machineConfig.closeTime')">
          <el-input 
            :value="localValue.closeTimeSet" 
            @input="handleChange('closeTimeSet', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.hours') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item :label="$t('machineConfig.orderTimeoutCharge')">
          <el-select 
            :value="localValue.orderTimeoutChargeSwitch" 
            @change="handleChange('orderTimeoutChargeSwitch', $event)" 
            filterable 
            clearable 
            :placeholder="$t('common.select')"
          >
            <el-option 
              v-for="item in yesNo" 
              :key="item.id" 
              :label="item.label" 
              :value="+item.value" 
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6" v-if="localValue.orderTimeoutChargeSwitch === 1">
        <el-form-item :label="$t('machineConfig.orderTimeoutSet')">
          <el-input 
            :value="localValue.orderTimeoutSet" 
            @input="handleChange('orderTimeoutSet', $event)" 
            placeholder="Enter number" 
            type="number" 
            autocomplete="off"
          >
            <template slot="append">{{ $t('machineConfig.minutes') }}</template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'OpenDoorSettings',
  props: {
    value: { type: Object, default: () => ({}) },
    yesNo: { type: Array, default: () => [] }
  },
  data() {
    return {
      detectTypeList: [
        { value: 1, label: this.$t('machineConfig.visualWeightDetection') },
        { value: 2, label: this.$t('machineConfig.visualDetection') },
        { value: 3, label: this.$t('machineConfig.weightDetection') }
      ],
      cameraSelectList: [
        { value: 1, label: this.$t('machineConfig.dualCamera') },
        { value: 2, label: this.$t('machineConfig.quadCamera') }
      ]
    };
  },
  computed: {
    localValue() {
      return this.value || {};
    }
  },
  methods: {
    handleChange(key, val) {
      this.$emit('input', { ...this.localValue, [key]: val });
    }
  }
};
</script>

<style lang="scss" scoped>
.open-door-settings {
  .config-section-title {
    height: 24px;
    line-height: 24px;
    font-size: 15px;
    font-weight: 500;
    color: #000000;
    padding-left: 10px;
    border-left: 5px solid #409eff;
    margin: 30px 0 5px 0;
    display: flex;
    align-items: center;
  }
}
</style>
